import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRequest } from '~/lib/useRequest';
import { config } from '~/config';
import { IntakesBulkPatchResponse, IntakesBulkPatchRequest } from '@ab/ams-school-api/types/private/v1';

export function useBulkPatchIntakes(intakeIds: string[]) {
  const queryClient = useQueryClient();
  const request = useRequest();
  const { mutateAsync, error, isLoading } = useMutation(['useBulkPatchIntakes', intakeIds], async (status: string) => {
    const response = await request<IntakesBulkPatchRequest['body']>(`${config.apiHost}/private/v1/intakes/bulk`, {
      body: {
        data: intakeIds.map((intakeId) => ({
          id: intakeId,
          type: 'intake',
          attributes: { isAvailable: status === 'open' },
        })),
      },
      method: 'PATCH',
      isExpectedResponse,
    });

    // reset intakes query to refrech the fresh data
    queryClient.resetQueries(['intakes']);

    return response.data;
  });
  return {
    pathIntakes: mutateAsync,
    pathIntakesError: error,
    isPatchingIntakes: isLoading,
  };
}

function isExpectedResponse(res: unknown): res is IntakesBulkPatchResponse['body'] {
  return Boolean(res && typeof res === 'object');
}
